import { RootState } from 'src/store/store';

export const selectTaxState = (state: RootState) => state.tax;
export const selectTaxPaymentPeriods = (state: RootState) =>
  state.tax.taxPaymentPeriods;
export const selectTaxSteps = (state: RootState) => state.tax.taxSteps;

export const selectCalculatedTaxData = (state: RootState) =>
  state.tax.calculatedTaxData;
export const selectCalculatedTaxInProgress = (state: RootState) =>
  state.tax.isCalculateTaxInProgress;
export const selectCalculatedTaxSuccess = (state: RootState) =>
  state.tax.isCalculateTaxSuccess;
export const selectCalculateTaxErrorMsg = (state: RootState) =>
  state.tax.calculatedTaxErrorMsg;

export const selectPreSelectedTaxPeriod = (state: RootState) =>
  state.tax.preSelectedPeriod;

export const selectTaxFlowData = (state: RootState) => state.tax.taxFlowData;
